import { CompressionOptions } from '@wtf/shared'

export const COMPRESSION_PRESETS: Record<string, CompressionOptions> = {
    AVATAR: {
        maxWidth: 512,
        maxHeight: 512,
        quality: 0.8,
        skipIfSmaller: 200, // Skip if under 200KB
    },
    USER_COVER: {
        maxWidth: 1920,
        maxHeight: 1080, // 16:9 aspect ratio for cover photos
        quality: 0.9,
        skipIfSmaller: 500, // Skip if under 500KB
    },
    COLLECTION_COVER: {
        maxWidth: 1920,
        maxHeight: 1440, // 4:3 aspect ratio (1920/1440 = 1.333...)
        quality: 0.9,
        skipIfSmaller: 500, // Skip if under 500KB
    },
    LOOK_COVER: {
        maxWidth: 1440,
        maxHeight: 1920, // 3:4 aspect ratio (1440/1920 = 0.75)
        quality: 0.9,
        skipIfSmaller: 500, // Skip if under 500KB
    },
    PRODUCT: {
        maxWidth: 2048,
        maxHeight: 2048,
        quality: 0.95,
        skipIfSmaller: 500, // Skip if under 500KB
    },
} as const
